import { RoomPassengers } from "../../types/hotels";

export const getRoomsFromUrl = (
  queryObj: Record<string, any>,
  isCbtArg?: boolean
): RoomPassengers[] | undefined => {
  const rooms: RoomPassengers[] = [];
  const queryKeys = Object.keys(queryObj || {});

  const isCbt = queryKeys.includes("travelReasonId") || isCbtArg;

  for (let i = 0; i < 10; i++) {
    if (
      queryKeys.includes(`room_${i}_ADT`) ||
      queryKeys.includes(`room_${i}_guests`)
    ) {
      const room: RoomPassengers = {
        ADT: !isCbt
          ? parseInt(queryObj[`room_${i}_ADT`] as string, 10) || 1
          : 0,
        CHD: parseInt(queryObj[`room_${i}_CHD`] as string, 10) || 0,
        guests: isCbt
          ? parseInt(queryObj[`room_${i}_guests`] as string, 10) || 0
          : 0,
        childAges: [],
      };

      if (room.CHD > 0) {
        for (let j = 0; j < room.CHD; j++) {
          if (queryObj[`room_${i}_CHD_age_${j}`]) {
            room.childAges.push(
              parseInt(queryObj[`room_${i}_CHD_age_${j}`] as string, 10)
            );
          } else {
            room.childAges.push(1);
          }
        }
      }

      rooms.push(room);
    }
  }

  return rooms.length > 0 ? rooms : undefined;
};
